import LandingHeader from "../components/header/LandingHeader";
import { fetchPage } from "../services/useFetch";
import { pageFilter } from "../services/cms/pages";
import { Typography, Link } from "@mui/material";
import { useEffect, useState } from "react";
import { getSiteInfo } from "../services/faq/getFaqInfo";
import parse from "html-react-parser";

const VendorFAQ = ({ pageData }) => {

  const [body, setBody] = useState();

  useEffect(() => {
    getFaqBody();
  }, []);

  const getFaqBody = async () => {
    const response = await getSiteInfo();

    setBody(response.faq_body);
  };
  // 
  return (
    <>
      <LandingHeader />
      <div className="wrapper-90">
        <Typography variant="h3" marginBottom={2}>
          The Boho Market Vendor FAQs
        </Typography>
        <div className="event_pg__faqLegacy">
          {body ? parse(body) : " "}

        </div>
        
      </div>
    </>
  );
};

export default VendorFAQ;
